import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import {
    FETCH_GOLF_LEADERBOARD,
    FETCH_GOLF_LEADERBOARD_FETCHING,
    FETCH_GOLF_LEADERBOARD_SUCCESS,
    FETCH_GOLF_LEADERBOARD_FAIL
} from 'actions/golfLeaderboardActions';

export function* fetchGolfLeaderboardSaga(action) {
    try {
        yield put({
            type: FETCH_GOLF_LEADERBOARD_FETCHING
        });

        const { scorecardId, courseId, date, leaderboardId, rowsPerPage, locale } = action;

        const query = toQueryString({ 'per-page': rowsPerPage, 'user-locale': locale });
        let url = `/gcs-golfcommunity/api/v2/leaderboard/${leaderboardId}${query}`;

        if (scorecardId) {
            url = `/gcs-golfcommunity/api/v2/leaderboard/scorecard/${scorecardId}${query}`;
        }

        if (courseId && date) {
            url = `/gcs-golfcommunity/api/v2/leaderboard/course/${courseId}/week-of/${date}${query}`;
        }

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_LEADERBOARD_SUCCESS,
            leaderboard: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_LEADERBOARD_FAIL
        });
    }
}

export const golfLeaderboard = [takeEvery(FETCH_GOLF_LEADERBOARD, fetchGolfLeaderboardSaga)];
